/* DOMNO. rewards portal — the post-review block.

   Copy is governed by Outputs/Rewards Portal/rewards-copy-deck.md. Do not invent lines here.

   ⚠ 14 Sep 2026 — REVIEWS NO LONGER EARN A FREE PIECE, so this file no longer promises one.
   Loox's own £10 stays and is Loox-side. The Trustpilot version was dropped outright: their
   guidelines forbid any benefit in exchange for a review, and enforcement runs to a Consumer
   Warning on the profile and the TrustScore being hidden.
   What is left is a thank-you, which is worth keeping — someone who went off and photographed
   their ring for us should be met with something when they come back, and "cheers for the photo"
   costs nothing. The four cases collapsed to two, because whether they had a piece before no
   longer changes anything.

   ⚠ THE DOT IS GONE FROM THIS FILE, AND IT WAS ALREADY DEAD. domno-saved.js (Dom, 12 Sep) hides
   `.dp-dot` with `display:none !important` and replaced it with `.dp-badge` on the header star.
   So every dot this file appended from 12 Sep onwards was invisible. The badge on the star is
   owned by domno-saved.js and nothing else should write to that icon — two modules decorating one
   icon is how you get two badges. If a reward indicator is wanted there, it belongs in saved.js
   with the badge it already owns.

   HOW WE KNOW IT WAS OURS: a marker written when they tapped Review inside the drawer, plus the
   worker reporting a review timestamped LATER than that marker. Clicking Review and wandering off
   proves nothing, and an old review from last month must not trigger it. A Loox-email reviewer
   never has a marker, so they never see this panel. That check stays even though nothing is paid
   out now — greeting the wrong person is worse than greeting nobody.

   ⚠ THE BLOCK MUST OUTLIVE THE PAINT. The first version painted into the Rewards panel while the
   drawer was still SHUT — the panel exists in the DOM the whole time — so it was consumed before
   anyone saw it. paint() refuses to run unless the overlay is genuinely open AND Rewards is the
   visible panel. */
(function(){
  var API = 'https://rewards.domno.com';
  var MARKER = 'dp_review_sent';
  var THANKS = 'dp_review_thanks';

  function ls(k){ try{ return localStorage.getItem(k); }catch(e){ return null; } }
  function lsSet(k,v){ try{ localStorage.setItem(k,v); }catch(e){} }
  function lsDel(k){ try{ localStorage.removeItem(k); }catch(e){} }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  function customerId(){
    try{
      if (window.DP_CUSTOMER && window.DP_CUSTOMER.id) return String(window.DP_CUSTOMER.id);
      if (window.__st && window.__st.cid) return String(window.__st.cid);
    }catch(e){}
    return '';
  }

  /* ---- 1. leave a marker when they head off to Loox from inside the drawer ---- */
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('a[href*="ref=review"]') : null;
    if (!a) return;
    if (!a.closest('#domno-portal')) return;          /* portal only — not a Loox email link */
    lsSet(MARKER, String(Date.now()));
  }, true);

  /* ---- 2. on the way back, ask the worker whether a review actually landed ----
     The credit ledger is no longer consulted. It used to be checked twice over — once for "did
     this review earn it" and once for "had they already had one" — and both questions stopped
     existing when reviews stopped paying. */
  async function check(){
    var raw = ls(MARKER);
    if (!raw) return;
    var sentAt = parseInt(raw, 10);
    if (!sentAt || (Date.now() - sentAt) > 6 * 60 * 60 * 1000){ lsDel(MARKER); return; }

    var cid = customerId();
    if (!cid) return;

    var data = null;
    try{
      var r = await fetch(API + '/api/review-status?cid=' + encodeURIComponent(cid), { credentials:'omit' });
      data = await r.json();
    }catch(err){ return; }

    if (!data || !data.ok || !data.reviewed || !data.last_review) return;

    var at = Date.parse(data.last_review.at || '');
    if (!at || at < (sentAt - 60000)) return;

    lsDel(MARKER);
    lsSet(THANKS, JSON.stringify({
      product: data.last_review.product || '',
      photo: !!data.last_review.has_photo
    }));
  }

  /* ---- 3. the block itself, at the top of Rewards ---- */
  function copyFor(t){
    var forProduct = t.product ? ' for <b>' + esc(t.product) + '</b>' : '';
    var head, body;

    if (t.photo){
      head = 'cheers for the photo';
      body = 'photos are the ones people actually read' + forProduct + ', so that one genuinely ' +
             'helps. big love.';
    } else {
      head = 'cheers for the review';
      body = 'appreciate you taking the time' + forProduct + '. if you ever fancy adding a photo, ' +
             'those are the ones people actually read.';
    }

    return '<div style="background:var(--panel);border:1px solid var(--line);padding:15px;margin:0 0 16px">' +
             '<div style="font-family:var(--disp);font-weight:900;font-style:italic;font-size:15px;margin-bottom:6px">' + head + '</div>' +
             '<div class="c" style="text-transform:none;line-height:1.6;margin:0">' + body + '</div>' +
           '</div>';
  }

  function paint(){
    var raw = ls(THANKS); if (!raw) return;
    var panel = document.getElementById('p-rewards'); if (!panel) return;

    var overlay = document.getElementById('dp-overlay');
    if (!overlay || !overlay.classList.contains('open')) return;
    if (!panel.classList.contains('on')) return;
    if (panel.querySelector('[data-dp-thanks]')) return;

    var t; try{ t = JSON.parse(raw); }catch(e){ lsDel(THANKS); return; }
    var wrap = document.createElement('div');
    wrap.setAttribute('data-dp-thanks','1');
    wrap.innerHTML = copyFor(t);
    panel.insertBefore(wrap, panel.firstChild);

    lsDel(THANKS);
  }

  function boot(){
    check();
    var n = 0, iv = setInterval(function(){
      n++;
      paint();
      if (n > 600) clearInterval(iv);
    }, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();